<div class="page-header">
  @if ({
    pageName: pageName$ | async,
    templateName: templateName$ | async,
    }; as content) {
    <h1>
      @if (content.templateName === 'SearchResultsListPageTemplate' || content.templateName === 'SearchResultsGridPageTemplate') {
        {{ 'category.search.title' | cxTranslate }}
      }
      <span>
        {{ content.pageName }}
      </span>
      @if (currentTerm) {
        <span>Results for: "{{ currentTerm }}" </span>
      }
    </h1>
  }
</div>
